import React, { Component } from "react";
import httpService from "../../services/httpService";
import config from "../../config.json";
import { Button } from "react-bootstrap";

class HledatOsobu extends Component {
  state = {};

  componentDidMount = () => {
    const { value } = this.props;
    this.setState({ srch: value });
  };

  timer = false;

  hledejOsobu = (srch) => {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => this.hledejOsobuDo(srch), 500);
    this.setState({ srch });
  };

  hledejOsobuDo = async (srch) => {
    if (srch.length > 3) {
      const osoby = await httpService.post(
        config.apiEndpoint + "user/hledatOsobu.php",
        { srch }
      );
      this.setState({ osoby: osoby.data, loaded: true });
    } else {
      this.setState({ osoby: null, loaded: false });
    }
  };

  zvolOsobu = (login) => {
    const { onSelect } = this.props;
    const { osoby } = this.state;
    const index = osoby.findIndex((o) => o.login === login);
    if (index >= 0) {
      this.setState({
        srch:
          osoby[index].jmeno +
          "(" +
          osoby[index].login +
          (osoby[index].mobil !== "" ? ", " + osoby[index].mobil : "") +
          ")",
      });
    }
    if (onSelect) {
      onSelect(login, index >= 0 && osoby[index].jmeno);
    }
    this.setState({ osoby: null, loaded: false });
  };

  render() {
    const { osoby, loaded, srch } = this.state;
    const { title } = this.props;
    return (
      <React.Fragment>
        <div style={{ position: "relative" }}>
          <small>{title ? title : "Hledat osobu"}</small>
          <input
            type="text"
            value={srch}
            onChange={(e) => this.hledejOsobu(e.target.value)}
            className="form-control"
          />
          {loaded && osoby && osoby.length > 0 && (
            <div
              style={{
                backgroundColor: "#FFF",
                border: "solid 1px #ddd",
                position: "absolute",
                top: "60px",
                zIndex: "999",
                width: "100%",
              }}
            >
              {osoby.map((o) => (
                <Button
                  variant="inline"
                  key={o.login}
                  style={{ display: "block", width: "100%", textAlign: "left" }}
                  onClick={() => this.zvolOsobu(o.login)}
                >
                  {o.jmeno} ({o.login}
                  {o.mobil && o.mobil !== "" && ", " + o.mobil})
                </Button>
              ))}
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default HledatOsobu;
